function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u79FB\\u81F3\\u6700\\u5F8C",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(3.000000, 3.000000)",
  fill: "#555555",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.08703221,6.7105695 L2.2323374,8.35016734 L2.215,8.362 L6.507,10.959 L7,10.9599729 L7,13.5944648 L1.0042142,9.96359762 C0.0602703648,9.48788236 -0.295939437,8.34565824 0.270106935,7.4499522 C0.35543885,7.31492384 0.449819648,7.21440163 0.582152642,7.09963157 L0.764355495,6.94980762 L1.08703221,6.7105695 Z M16.7665211,8.34936785 L17.9100394,6.70852407 L18.1255106,6.86518374 L18.31103,7.01012077 C18.5024244,7.16629716 18.6232282,7.28116675 18.7298931,7.4499522 C19.2689848,8.30300557 18.9715631,9.37965811 18.184984,9.85889362 L18.0633719,9.92619569 L12,13.5944648 L12,10.9599729 L12.492,10.959 L16.786,8.363 L16.7665211,8.34936785 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.65807804,-0.81294925 C9.13519561,-1.03741015 9.68799074,-1.05985624 10.1802438,-0.88028752 L10.341899,-0.81294925 L17.9487431,2.76570555 C18.9039694,3.21509367 19.2958954,4.34441277 18.7581861,5.25589182 C18.6090813,5.50864168 18.3996989,5.72039152 18.1892642,5.85498584 L18.0633509,5.92619454 L12,9.59446946 L12,6.95997289 L12.492,6.959 L16.726,4.4 L9.5,1 L2.276,4.399 L6.507,6.959 L7,6.95997289 L7,9.59446946 L1.0042142,5.96359762 C0.0602703648,5.48788236 -0.295939437,4.34565824 0.270106935,3.4499522 C0.426529331,3.20243098 0.641548548,2.9972545 0.894833651,2.84825405 L1.05123397,2.76570555 L8.65807804,-0.81294925 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  transform: "translate(9.500000, 17.221089) rotate(-180.000000) translate(-9.500000, -17.221089) ",
  points: "5.34920863 18.2407434 9.5 14.6829222 13.6507914 18.2407434 12.3492086 19.7592566 9.5 17.317 6.65079137 19.7592566"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  points: "10.5 6 10.5 20 8.5 20 8.5 6"
}))));

function SvgToBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u79FB\u81F3\u6700\u5F8C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToBottom);
export default __webpack_public_path__ + "static/media/toBottom.2db5d9aa.svg";
export { ForwardRef as ReactComponent };